import React from "react";
import { LogRenderContext } from "../LogRenderer";
import ClearCancelled from "../common/ClearCancel";
import { getMediaDetails } from "../utils";

const MediaClearCancelled = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, id, updatedBy, updatedAt } = getMediaDetails(log);
  return <ClearCancelled name={name} id={id} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default MediaClearCancelled;
